/**
 * Copyright © 2026 Adnuntius AS.
 */
export function isIabCategoryEnabledForNetwork(networkTag: string): boolean {
  return networkTag === '107727';
}
